import React from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

/**
 * Shown when a user is authenticated but does not have admin access to the
 * portal. This must NOT redirect to `/auth/login`: the user is already
 * authenticated, so `Routes.js` would bounce `/auth` -> `/` -> `/manage/...`
 * straight back here, producing an infinite redirect loop (React error #185).
 */
export function AccessDenied({ user }) {
  const name = user?.name || user?.email || user?.user_name || "";
  const roleName = user?.role_name || user?.roleName || "";

  return (
    <div className="d-flex flex-column flex-root">
      <div
        className="d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30"
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/error/bg1.jpg")})`,
        }}
      >
        <h1
          className="font-size-sm-100 font-weight-boldest text-dark-75 mt-15"
          style={{ fontSize: "120px" }}
        >
          403
        </h1>
        <p className="font-size-h3 font-weight-light mb-2">
          You don&apos;t have access to this portal.
        </p>
        <p className="font-size-h5 font-weight-light text-muted mb-10">
          {name ? (
            <>
              Signed in as <strong>{name}</strong>
              {roleName ? ` (${roleName})` : ""}. This account isn&apos;t
              authorized for admin access. Please contact an administrator if you
              believe this is a mistake.
            </>
          ) : (
            "This account isn't authorized for admin access. Please contact an administrator if you believe this is a mistake."
          )}
        </p>
        <div>
          <Link to="/logout" className="btn btn-primary font-weight-bold px-6 py-4">
            Sign in with a different account
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AccessDenied;
